import { render, staticRenderFns } from "./MEM924P01.vue?vue&type=template&id=11189672&"
import script from "./MEM924P01.vue?vue&type=script&lang=js&"
export * from "./MEM924P01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports